import { EDataLayerEventType, sendEvent } from "./dataLayer";

export enum EDataLayerPrequalResponse {
    SUCCESS = "SUCCESS",
    NOT_AVAILABLE = "NOT_AVAILABLE",
    FAILURE = "FAILURE",
}

export interface IDataLayerPrequalEvent {
    event: EDataLayerEventType.PREQUAL;
    prequalResponse: EDataLayerPrequalResponse;
}

export const sendPrequalEvent = (prequalResponse: EDataLayerPrequalResponse) => {
    sendEvent({
        event: EDataLayerEventType.PREQUAL,
        prequalResponse,
    });
};
